<template>
    <b-overlay :show="loaded" rounded="sm">
        <b-list-group>
            <b-list-group-item class="d-flex justify-content-between">
                <div class="form-check">
                    <label class="form-check-label lh-base">
                        <input
                            type="checkbox"
                            class="form-check-input top-2"
                            id="checkbox-expandedList"
                            v-model="expandedList"
                            name="checkbox-expandedList"
                            :value="true"
                            :unchecked-value="false"
                        />
                        {{ $translate('expand') }}
                        <i class="input-helper"></i>
                    </label>
                </div>

                <b-button-group size="sm">
                    <b-button
                        v-show="permissionGroups.length > 0"
                        class="me-2"
                        variant="info"
                        @click="doCheckAll(true)"
                    >
                        {{ $translate('check_all') }}
                    </b-button>
                    <b-button
                        v-show="permissionGroups.length > 0"
                        variant="info"
                        @click="doCheckAll(false)"
                        >{{ $translate('uncheck_all') }}</b-button
                    >
                </b-button-group>
            </b-list-group-item>
            <b-list-group-item>
                <b-row>
                    <b-col cols="2">
                        <h6>{{ $translate('no') }}</h6>
                    </b-col>
                    <b-col cols="3" md="4">
                        <h6>{{ $translate('section') }}</h6>
                    </b-col>
                    <b-col cols="1">
                        <h6 class="d-block d-md-none">
                            {{ $translate('create_role_short') }}
                        </h6>
                        <h6 class="d-none d-md-block">{{ $createLabel() }}</h6>
                    </b-col>
                    <b-col cols="1">
                        <h6 class="d-block d-md-none">
                            {{ $translate('view_role_short') }}
                        </h6>
                        <h6 class="d-none d-md-block">{{ $viewLabel() }}</h6>
                    </b-col>
                    <b-col cols="1">
                        <h6 class="d-block d-md-none">
                            {{ $translate('update_role_short') }}
                        </h6>
                        <h6 class="d-none d-md-block">{{ $updateLabel() }}</h6>
                    </b-col>
                    <b-col cols="1">
                        <h6 class="d-block d-md-none">
                            {{ $translate('delete_role_short') }}
                        </h6>
                        <h6 class="d-none d-md-block">{{ $deleteLabel() }}</h6>
                    </b-col>
                </b-row>
            </b-list-group-item>
            <b-list-group-item
                v-for="(item, idx) in permissionGroups"
                :key="`section--${idx}`"
            >
                <b-row>
                    <b-col cols="2">{{ idx + 1 }}</b-col>
                    <b-col cols="3" md="4">
                        <p>{{ item.section | formatSlug }}</p>
                    </b-col>
                    <b-col cols="1">
                        <div class="form-check">
                            <label class="form-check-label">
                                <input
                                    type="checkbox"
                                    @change="
                                        setPermission(idx, 'create', $event)
                                    "
                                    class="form-check-input"
                                    :id="`create-${idx}`"
                                    v-model="item.actions['create']"
                                    name="checkbox-1"
                                    :value="true"
                                    :unchecked-value="false"
                                    :disabled="permission_creating"
                                />
                                <i class="input-helper"></i>
                            </label>
                        </div>
                    </b-col>
                    <b-col cols="1">
                        <div class="form-check">
                            <label class="form-check-label">
                                <input
                                    type="checkbox"
                                    @change="setPermission(idx, 'view', $event)"
                                    :id="`view-${idx}`"
                                    v-model="item.actions['view']"
                                    name="checkbox-1"
                                    :value="true"
                                    :unchecked-value="false"
                                    :disabled="permission_creating"
                                />
                                <i class="input-helper"></i>
                            </label>
                        </div>
                    </b-col>
                    <b-col cols="1">
                        <div class="form-check">
                            <label class="form-check-label">
                                <input
                                    type="checkbox"
                                    @change="
                                        setPermission(idx, 'update', $event)
                                    "
                                    :id="`update-${idx}`"
                                    v-model="item.actions['update']"
                                    name="checkbox-1"
                                    :value="true"
                                    :unchecked-value="false"
                                    :disabled="permission_creating"
                                />
                                <i class="input-helper"></i>
                            </label>
                        </div>
                    </b-col>
                    <b-col cols="1">
                        <div class="form-check">
                            <label class="form-check-label">
                                <input
                                    type="checkbox"
                                    @change="
                                        setPermission(idx, 'delete', $event)
                                    "
                                    :id="`delete-${idx}`"
                                    v-model="item.actions['delete']"
                                    name="checkbox-1"
                                    :value="true"
                                    :unchecked-value="false"
                                    :disabled="permission_creating"
                                />
                                <i class="input-helper"></i>
                            </label>
                        </div>
                    </b-col>
                    <b-col cols="1" v-if="userCheckbox(item)">
                        <div class="form-check">
                            <label class="form-check-label">
                                <input
                                    type="checkbox"
                                    @change="
                                        setPermission(idx, 'disable', $event)
                                    "
                                    :id="`delete-${idx}`"
                                    v-model="item.actions['disable']"
                                    name="checkbox-1"
                                    :value="true"
                                    :unchecked-value="false"
                                    :disabled="permission_creating"
                                />
                                <i class="input-helper"></i> </label
                            ><br />{{ $translate('disable') }}
                        </div>
                    </b-col>
                    <b-col cols="1" v-if="userCheckbox(item)">
                        <div class="form-check">
                            <label class="form-check-label">
                                <input
                                    type="checkbox"
                                    @change="
                                        setPermission(idx, 'restore', $event)
                                    "
                                    :id="`delete-${idx}`"
                                    v-model="item.actions['restore']"
                                    name="checkbox-1"
                                    :value="true"
                                    :unchecked-value="false"
                                    :disabled="permission_creating"
                                />
                                <i class="input-helper"></i> </label
                            ><br />{{ $translate('restore') }}
                        </div>
                    </b-col>
                </b-row>
            </b-list-group-item>
        </b-list-group>
    </b-overlay>
</template>
<script>
import { capitalCase } from 'change-case'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'PermissionGroups',
    data() {
        return {
            loaded: null,
            permissionGroups: [],
            expandedList: false,
            permission_creating: false,
        }
    },
    props: ['value'],
    mixins: [permissionsMixins],
    filters: {
        formatSlug(slug) {
            if (slug === 'order.categories') slug = 'activity.categories'
            if (slug === 'order.templates') slug = 'activity.templates'
            if (slug === 'order.types') slug = 'activity.types'
            if (slug === 'orders') slug = 'activities'
            return capitalCase(slug.split('.').join('-'))
        },
    },
    computed: {
        permissions_list() {
            return this.$store.state.permissions.permissions_list
        },
    },
    watch: {
        value: {
            handler: function (val) {
                console.log('watch---value', val)
                this.setModel(val)
            },
            deep: true,
        },
        expandedList: function () {
            this.setModel(this.value)
        },
        permissions_list: {
            handler: function () {
                this.$nextTick(() => {
                    this.updateValues()
                })
            },
            deep: true,
        },
    },
    mounted() {
        console.log('mounted---value', this.value)
        this.setModel(this.value)
        console.log('mounted---permissions_list', this.permissions_list)
    },
    methods: {
        userCheckbox(item) {
            return item.section == 'users'
        },
        async createPermissionIfNotExists(action, section) {
            const slug = `${action}.${section}`
            console.log('slug', slug)
            const permission = this.permissions_list.find(x => x.slug === slug)
            if (permission) {
                return true
            } else {
                const name = capitalCase(action)
                section = capitalCase(section.split('.').join(' '))
                try {
                    this.permission_creating = true
                    await this.$store.dispatch('permissions/create', {
                        name,
                        section,
                    })
                    this.permission_creating = false
                } catch (err) {
                    console.error('createPermissionIfNotExists', err)
                    this.doToast(this.$translate('error'), err, 'danger')
                } finally {
                    this.permission_creating = false
                }
                return false
            }
        },

        async setPermission(idx, action) {
            const group = this.permissionGroups[idx]
            const alreadyExists = await this.createPermissionIfNotExists(
                action,
                group.section
            )
            if (alreadyExists) this.updateValues()
        },

        updateValues() {
            let values = []
            for (let value of this.permissionGroups) {
                //const object = { a: 1, b: 2, c: 3 };
                for (let actionKey in value.actions) {
                    //for (const property in object) {
                    console.log()
                    if (value.actions[actionKey]) {
                        const slug = `${actionKey}.${value.section}`
                            .split(' ')
                            .join('.')
                            .toLowerCase()
                        const option = this.permissions_list.find(
                            x => x.slug === slug
                        )
                        if (option) {
                            const name = option.name
                            values.push({
                                name,
                                slug,
                            })
                        }
                    }
                }
            }
            console.log('new permission permissionGroups', values)
            this.$emit('input', values)
        },
        sleeper(ms) {
            return new Promise(resolve => setTimeout(() => resolve(), ms))
        },
        loader(select) {
            this.loaded = select
        },
        async doCheckAll(selected) {
            this.loader(true)
            const $this = this
            for (let i = 0; i < this.permissionGroups.length; i++) {
                const { section } = this.permissionGroups[i]
                const actions = {
                    create: selected,
                    view: selected,
                    update: selected,
                    delete: selected,
                    disable: selected,
                    restore: selected,
                }
                await Promise.all(
                    [
                        'create',
                        'view',
                        'update',
                        'delete',
                        'disable',
                        'restore',
                    ].map(x => $this.createPermissionIfNotExists(x, section))
                )
                this.$set($this.permissionGroups, i, { section, actions })
                await this.sleeper(500)
            }
            this.updateValues()
            this.loader(false)
        },

        setModel(values) {
            const _groupedSections = (values || []).reduce((_list, x) => {
                const parts = x.slug.split('.')
                const action = parts[0]
                const section = parts.slice(1).join('.')
                const idx = _list.findIndex(x => x.section === section)
                if (idx < 0) {
                    const actions = {
                        create: false,
                        update: false,
                        delete: false,
                        view: false,
                    }
                    actions[action] = true
                    _list.push({
                        section,
                        actions,
                    })
                } else {
                    const obj = _list[idx]
                    obj.actions[action] = true
                    _list.splice(idx, 1, obj)
                }
                return _list
            }, [])

            const slugSections = this.permissionSections.map(x =>
                x.split(' ').join('.').toLowerCase()
            )
            const _cleanGroupedSections = slugSections.map(section => {
                const _groupSection = _groupedSections.find(
                    _group => _group.section === section
                )
                if (_groupSection) {
                    return _groupSection
                }

                const actions = {
                    create: false,
                    update: false,
                    delete: false,
                    view: false,
                }

                return {
                    section,
                    actions,
                }
            })

            _cleanGroupedSections.sort((a, b) => {
                if (a.section > b.section) return 1
                else if (b.section > a.section) return -1
                else return 0
            })

            const isExpanded = this.expandedList
            this.permissionGroups = _cleanGroupedSections.filter(x => {
                if (isExpanded) return true
                else {
                    let allFalse = false
                    for (let prop in x.actions) {
                        allFalse = allFalse || x.actions[prop]
                    }
                    return allFalse
                }
            })
        },
    },
}
</script>
